import apiClient from "../../../../helpers/api-client";

type RequestedPlatform = {
	name: string;
	link: string;
};

export async function sendPlatformRequestEmailCSM(platform: RequestedPlatform): Promise<boolean> {
	const supportEmail = apiClient.support as {
		sendPlatformRequestEmailCSM: (p: RequestedPlatform) => Promise<boolean>;
	};

	const timeout = new Promise<boolean>((resolve) => {
		setTimeout(() => resolve(false), 5000);
	});

	try {
		return await Promise.race([supportEmail.sendPlatformRequestEmailCSM(platform), timeout]);
	} catch (error) {
		console.error(error);
		return false;
	}
}
